import React from 'react';
import VeritasHeader from "./VeritasHeader";
import {Grid} from "semantic-ui-react";
import {connect} from "react-redux";
import {fetchAllServices} from "../data-services/actions/ServicesActions";
import {fetchAllOrganizations} from "../data-providers/actions/DataProviderActions";
import { setBreadCrumb } from '../breadcrumb/BreadcrumbActions';
import Breadcrumb from '../../common/partials/Breadcrumb';
import {loadResourcesForDPServiceForm} from "../add-edit/actions/AddEditDPServiceActions";
import {fetchAllCountries} from "../country-coverage/actions/CountriesActions";
import {fetchAllBillingGroups} from "../billing-groups/actions/BillingGroupActions";
import Sidebar from "../../common/components/Sidebar";
import VeritasSidebarButtons from "./VeritasSidebarButtons";

export class VeritasHomePage extends React.Component {

    componentDidMount() {
        document.title = `Veritas - Home`;
        // Only make the API call when the component is called for the first time.
        const {
            all_services,
            all_countries,
            all_organizations,
            all_billing_groups,
            all_service_sets,
            all_service_config_names
        } = this.props;

        if (all_services.length === 0) {
            this.props.getAllServices();
        }
        if (all_organizations.length === 0) {
            this.props.getAllOrganizations();
        }
        if (all_countries.length === 0) {
            this.props.getAllCountries();
        }
        if (all_billing_groups.length === 0 || all_service_sets.length === 0 || all_service_config_names.length === 0) {
            this.props.getSupportingSelections();
        }
        if (all_billing_groups.length === 0) {
            this.props.getAllBillingGroups();
        }

        this.props.setBreadCrumb({
            parent:  { url: '/veritas', text: 'Veritas' },
            list:    { url: '', text: ''},
            service: { url: '', text: ''},
            source:  { url: '', text: ''},
        })
    }

    pageContent() {
        return (<div style={{padding: "20px 20px 0 30px"}}> WELCOME TO VERITAS </div>)
    };

    render() {

        return (
            <div className="veritas">
                <VeritasHeader />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <VeritasSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {this.pageContent()}
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    all_services: state.veritas.services.all_services,
    all_countries: state.veritas.countries.all_countries,
    all_providers: state.veritas.providers.all_providers,
    all_organizations: state.veritas.providers.all_organizations,
    all_billing_groups: state.veritas.billingGroups.all_billing_groups,
    all_service_sets: state.veritas.services.all_service_sets,
    all_service_config_names: state.veritas.services.all_service_config_names,
});

const mapDispatchToProps = dispatch => ({
    getAllServices: () => {dispatch(fetchAllServices())},
    getAllCountries: () => {dispatch(fetchAllCountries())},
    getAllOrganizations: () => {dispatch(fetchAllOrganizations())},
    getAllBillingGroups: () => {dispatch(fetchAllBillingGroups())},
    setBreadCrumb: (crumb) => {dispatch(setBreadCrumb(crumb))},
    getSupportingSelections: () => {dispatch(loadResourcesForDPServiceForm())},
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(VeritasHomePage)
